import { render, staticRenderFns } from "./ClientEditTabAccount.vue?vue&type=template&id=33bcea52&"
import script from "./ClientEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports